import React, {Fragment, useRef, useState, useEffect} from 'react'
import {useDispatch, useSelector} from "react-redux"
import DateFnsUtils from "@date-io/date-fns"

// Material-UI Cord
import {makeStyles, withStyles} from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import Tooltip from '@material-ui/core/Tooltip'
import TextField from '@material-ui/core/TextField'
import Typography from '@material-ui/core/Typography'

import Fab from '@material-ui/core/Fab'
import Box from '@material-ui/core/Box'

// Material-UI Lab
import Autocomplete from '@material-ui/lab/Autocomplete'
import ToggleButton from '@material-ui/lab/ToggleButton'
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup'

// Material-UI Element
import {MuiPickersUtilsProvider, KeyboardDatePicker} from "@material-ui/pickers"

// Material-UI Icon
import FolderIcon from '@material-ui/icons/Folder'
import StorageIcon from '@material-ui/icons/Storage'
import PublishIcon from '@material-ui/icons/Publish'

// Custom Component
import LockScreenLoading from '../LockScreenLoading/LockScreenLoading'
import {Alert} from '../Alert/Alert'
import ConfirmDialog from '../Dialog/ConfirmDialog'
import FullScreenDialog from "../Dialog/FullScreenDialog"
import Legend from '../Legend/Legend'
import Efiling from '../../views/Efiling/Efiling.js'
import DrawingFileZoneContent from './DrawingFileZoneContent'
import FileDropzone from '../FileDropzone/FileDropzone'
import FilePreview from '../FilePreview/FilePreview'
import WebViewer from "../WebViewer/WebViewer"

// Custom Style
import {redColor, oceanBlueColor, grayColor, blackColor, DodgerBlueColor} from '../../styles/jss/cmsMainStyle'
import {uploadDrawingFormStyle} from '../../styles/jss/components/drawingRegister/uploadDrawingFormStyle'

// Global Function
import {getFile} from "../../global/getPropertyInfo"

// Fetch Data
import {getCoverType, createUnpublish} from '../../dataSource/drawingRegister'
import {fileUpload} from '../../dataSource/fileManager'



// Custom Style (Typography)
const InboxTypography = withStyles({
	root: {
		"fontSize": 12,
		"fontWeight": 400,
		"color": "red",
	},
}) (Typography)


const useStyles = makeStyles(theme => uploadDrawingFormStyle(theme))

const UploadDrawingForm = props => {
	const {openUnpublishDetail} = props
	const classes = useStyles()
	const dispatch = useDispatch()

	// Redux Data
	const propertySeqRedux = useSelector(state => state.propertySeqRedux)
	const fileUploadingPropertyRedux = useSelector(state => state.fileUploadingPropertyRedux)
	const tabmenuChangeRedux = useSelector(state => state.tabmenuChangeRedux)

	// State Variable
	const [coverTypeList, setCoverTypeList] = useState(null)
	const [aiCompanyList, setAiCompanyList] = useState([])
	const [bdCompanyList, setBdCompanyList] = useState([])
	const [drawingProperty, setDrawingProperty] = useState(null)
	const [fileUploadingProperty, setFileUploadingProperty] = useState([])
	const [filePreviewProperty, SetFilePreviewProperty] = useState(null)
	const [propertyFiles, setPropertyFiles] = useState(null)
	const [validationErrors, setValidationErrors] = useState({})
	const [coverType, setCoverType] = useState(null)
	const [webViewProps, setWebViewProps] = useState(null)
	const [webViewCloseDoc, setWebViewCloseDoc] = useState(false)
	const [lockScreenLoadingOpen, setLockScreenLoadingOpen] = useState(false)
	const [lockScreenProgressTitle, setLockScreenProgressTitle] = useState("")


	// Dialog contral state
	const [fileManagerDialogOpen, setFileManagerDialogOpen] = useState(false)
	const [filePreviewDialogOpen, setFilePreviewDialogOpen] = useState(false)

	// Alert dialog contral state
	const [alertOpen, setAlertOpen] = useState(false)
	const [alertData, setAlertData] = useState({
		type: "",
		title: "",
		content: ""
	})

	// Confirm dialog contral State
	const [confirmDialogOpen, setConfirmDialogOpen] = useState(false)
	const [confirmDialogData, setConfirmDialogData] = useState({
		dialogTitle: "",
		dialogContent: "",
		confirmAction: "",
		cancelAction: ""
	})


	// Define Template
	const drawingPropertyTemplate = {
		cover_type_seq: "",
		files: [],
	
		cover: {
			ai_cover_no: "",
			ai_issue_date: "",
			ai_company_seq: "-1",
			ai_cover_subject: "",
			bd_cover_no: "",
			bd_issue_date: "",
			bd_company_seq: "-1",
			bd_cover_subject: ""
		},
	}


	// Set Alert Content
	const buildAlert = (data) => {
		setAlertData({
			type: data.type,
			title: data.title,
			content: data.content
		})
		setAlertOpen(true)
	}

	// Set Confirm Dialog Content
	const buildConfirmDialog = (data) => {
		setConfirmDialogData({
			dialogTitle: data.dialogTitle,
			dialogContent: data.dialogContent,
			confirmAction: data.confirmAction,
			cancelAction: data.cancelAction
		})
	}


	// Input Handle
	const handleCoverType = (event, selectedCoverType) => {
		setValidationErrors({})
		setCoverType(selectedCoverType)
		setAiCompanyList(selectedCoverType.ai_companies)
		setBdCompanyList(selectedCoverType.bd_companies)
		
		const res = {...drawingProperty}
		res.cover_type_seq = selectedCoverType ? selectedCoverType.type_seq : null

		setDrawingProperty(res)
		dispatch({
			type: "ADD_DRAWING_PROPERTY",
			data: res
		})
	}

	const handleTextChange = event => {
		const {name, value} = event.target
		const res = {...drawingProperty}
		res.cover[name] = value

		setDrawingProperty(res)
		dispatch({
			type: "ADD_DRAWING_PROPERTY",
			data: res
		})

		validate(res)
	}

	const handleAiIssueDateChange = date => {
		const res = {...drawingProperty}
		res.cover.ai_issue_date = date

		setDrawingProperty(res)
		dispatch({
			type: "ADD_DRAWING_PROPERTY",
			data: res
		})

		validate(res)
	}

	const handleBdIssueDateChange = date => {
		const res = {...drawingProperty}
		res.cover.bd_issue_date = date

		setDrawingProperty(res)
		dispatch({
			type: "ADD_DRAWING_PROPERTY",
			data: res
		})

		validate(res)
	}

	// const handleAiSelectChange = (event, value) => {
	// 	const res = {...drawingProperty}
	// 	res.cover.ai_company_seq = value ? value.company_seq : 0

	// 	setDrawingProperty(res)
	// 	dispatch({
	// 		type: "ADD_DRAWING_PROPERTY",
	// 		data: res
	// 	})

	// 	validate(res)
	// }

	const handleBdSelectChange = (event, value) => {
		const res = {...drawingProperty}
		res.cover.bd_company_seq = value ? value.company_seq : 0

		setDrawingProperty(res)
		dispatch({
			type: "ADD_DRAWING_PROPERTY",
			data: res
		})

		validate(res)
	}


	// Confirm Dialog Contral Function
	const confirmDialogHandleOpen = (data) => {
		buildConfirmDialog(data)
		setConfirmDialogOpen(true)
	}

	const confirmDialogHandleClose = () => {
		setConfirmDialogOpen(false)
	}


	// Dialog Contral Function
	const fileManagerDialogHandleOpen = () => {
		setFileManagerDialogOpen(true)
	}

	const fileManagerDialogHandleClose = () => {
		setFileManagerDialogOpen(false)
	}

	const filePreviewDialogHandleOpen = () => {
		setFilePreviewDialogOpen(true)
	}

	const filePreviewDialogHandleClose = () => {
		setFilePreviewDialogOpen(false)
	}


	// Dialog Button Function
	const fileManagerFileSelected = async () => {
		if (propertySeqRedux === null) {
			buildAlert({
				// Alert Type: success, info, warning, error
				type: "warning",
				title: "Warning Alert",
				content: "Not any file choice, Please choice the file first."
			})

			return
		}

		if (propertySeqRedux.length === 0) {
			buildAlert({
				// Alert Type: success, info, warning, error
				type: "warning",
				title: "Warning Alert",
				content: "Not any file choice, Please choice the file first."
			})

			return
		}

		setPropertyFiles(await getFile(propertySeqRedux))
		fileManagerDialogHandleClose()
	}


	const fileUploadAction = (fileType, acceptedFilesPool) => {
		let UploadingSource = buildFileUploadingProperty(acceptedFilesPool)

		acceptedFilesPool.map(file => {
			fileUpload(file).then(res => {
				console.log("*****************************************************************************")
				console.log("Temporary upload File Successful")
				console.log(res)
				console.log("*****************************************************************************")

				UploadingSource = removeFileUploadingProperty(UploadingSource, file)
				buildFileRecordFromHarddisk(fileType, res.data[0])
			})
		})
	}


	const buildFileUploadingProperty = fileUploadRecord => {
		const res = [...fileUploadingProperty, ...fileUploadRecord]

		setFileUploadingProperty(res)
		dispatch({
			type: "ADD_FILE_UPLOADING_PROPERTY",
			data: res
		})

		return res
	}


	const removeFileUploadingProperty = (sourceRecords, key) => {
		if (sourceRecords) {
			const res = sourceRecords.filter(sourceRecord => sourceRecord !== key)

			setFileUploadingProperty(res)
			dispatch({
				type: "ADD_FILE_UPLOADING_PROPERTY",
				data: res
			})

			return res
		}
	}


	const buildFileRecordFromHarddisk = (fileType, fileUploadRecord) => {
		const res = {...drawingProperty}
		res.files.push(fileUploadRecord)
	
		setDrawingProperty(res)
		dispatch({
			type: "ADD_DRAWING_PROPERTY",
			data: res
		})

		validate(res)
	}

	const buildFileRecordFromEfiling = () => {
		let data = {...drawingProperty}
		
		if (propertyFiles !== null) {
			data.files.push(...propertyFiles)
		}

		setDrawingProperty({...drawingProperty, ...data})
		dispatch({
			type: "ADD_DRAWING_PROPERTY",
			data: {...drawingProperty, ...data}
		})

		validate({...drawingProperty, ...data})
	}

	const viewFileAction = (fileCat, fileSeq, filename) => {
		setWebViewProps({
			file_cat: fileCat,
			file_ref: fileSeq,
			file_name: filename,
			from: "API",
			autoLoading: false,
		})
	}


	const removeFileAction = (fileRecord) => {
		let result
		let data = {...drawingProperty}

		result = [...drawingProperty.files].filter(res => res !== fileRecord)
		data.files = result

		// setWebViewProps(true)
		setWebViewCloseDoc(true)

		setDrawingProperty({...drawingProperty, ...data})
		dispatch({
			type: "ADD_DRAWING_PROPERTY",
			data: {...drawingProperty, ...data}
		})

		confirmDialogHandleClose()
	}

	const removeFileConfirmAction = (fileRecord) => {
		confirmDialogHandleOpen({
			dialogTitle: "Remove the drawing",
			dialogContent: "Are you sure to remove the drawing file.",
			confirmAction: () => removeFileAction(fileRecord),
			cancelAction: removeFileCancelAction
		})
	}

	const removeFileCancelAction = () => {
		confirmDialogHandleClose()
	}


	const uploadDrawingConfirmAction = () => {
		if (validate()) {
			confirmDialogHandleOpen({
				dialogTitle: "Drawing Upload",
				dialogContent: "Are you sure to upload the new drawing.",
				confirmAction: () => uploadDrawingAction(),
				cancelAction: uploadDrawingCancelAction
			})
        }
	}

	const uploadDrawingCancelAction = () => {
		confirmDialogHandleClose()
	}

	const uploadDrawingAction = () => {
		confirmDialogHandleClose()

		setLockScreenProgressTitle("Processing...")
		setLockScreenLoadingOpen(true)

		// buildAlert({
		// 	// Alert Type: success, info, warning, error
		// 	type: "warning",
		// 	title: "System Processing......",
		// 	content: "Don't close any screen"
		// })

		createUnpublish(drawingProperty).then(res => {
			console.log("*****************************************************************************")
			console.log("System Module: Drawing Register")
			console.log("Message: Upload drawing to un-publish list successfully.")
			console.log(res)
			console.log("*****************************************************************************")

			// setUnpublishSeq(res.data[0].unpublish_seq)
		
			buildAlert({
				// Alert Type: success, info, warning, error
				type: "success",
				title: "Success Alert",
				content: "The drawing have been uploaded"
			})

			setTimeout(() => {
				tabmenuChangeRedux(null, 0)
				openUnpublishDetail(res.data[0].unpublish_seq)

				setLockScreenLoadingOpen(false)
				setLockScreenProgressTitle("")
			}, 1500)
		})
	}


	// Dialog Button
	const fileManagerDialogBtn = [
		{
			buttonName: "OK",
			buttonFunction: fileManagerFileSelected,
			chooseFile: false
		},
	]


	// Input Validation
	const validate = (fieldValues = drawingProperty) => {
		let temp = {...validationErrors}
	
		if (coverType && coverType.contain_ai) {
			if ("ai_cover_no" in fieldValues.cover) {
				temp.ai_cover_no = fieldValues.cover.ai_cover_no ? "" : "This field is required"
			}
	
			if ("ai_issue_date" in fieldValues.cover) {
				temp.ai_issue_date = fieldValues.cover.ai_issue_date ? "" : "This field is required"
			}
	
			// if ("ai_company_seq" in fieldValues.cover) {
			// 	temp.ai_company_seq = fieldValues.cover.ai_company_seq !== "-1" ? "" : "This field is required"
			// }
	
			if ("ai_cover_subject" in fieldValues.cover) {
				temp.ai_cover_subject = fieldValues.cover.ai_cover_subject ? "" : "This field is required"
			}
		}

		if (coverType && coverType.contain_bd) {
			if ("bd_cover_no" in fieldValues.cover) {
				temp.bd_cover_no = fieldValues.cover.bd_cover_no ? "" : "This field is required"
			}
	
			if ("bd_issue_date" in fieldValues.cover) {
				temp.bd_issue_date = fieldValues.cover.bd_issue_date ? "" : "This field is required"
			}
	
			// if ("bd_company_seq" in fieldValues.cover) {
			// 	temp.bd_company_seq = fieldValues.cover.bd_company_seq !== "-1" ? "" : "This field is required"
			// }
	
			if ("bd_cover_subject" in fieldValues.cover) {
				temp.bd_cover_subject = fieldValues.cover.bd_cover_subject ? "" : "This field is required"
			}
		}


		// if ("cover_type_seq" in fieldValues) {
		// 	temp.cover_type_seq = fieldValues.cover_type_seq ? "" : "This field is required"
		// }

		if ("files" in fieldValues) {
			temp.files = fieldValues.files.length > 0 ? "" : "This field is required"
		}

		setValidationErrors({...temp})

		if (fieldValues == drawingProperty) {
			return Object.values(temp).every(x => x == "")
		}
	}


	useEffect(() => {
		buildFileRecordFromEfiling()
	}, [propertyFiles])

	
	useEffect(() => {
		setDrawingProperty(drawingPropertyTemplate)
		dispatch({
			type: "ADD_DRAWING_PROPERTY",
			data: drawingPropertyTemplate
		})
		
		getCoverType().then(res => {
			setCoverTypeList(res)
		})
		.catch(error => {
			console.error("Get cover type list error: ", error)
		})
	}, [])



	return (
		// console.log("Cover Type List | Variable: coverTypeList (UploadDrawingForm.js)"),
		// console.log(coverTypeList),

		// console.log("Selected Cover Type List | Variable: coverType (UploadDrawingForm.js)"),
		// console.log(coverType),

		// console.log("Company List for Drawing Register | Variable: companyList (UploadDrawingForm.js)"),
		// console.log(companyList),

		// console.log("Property Seqance for file select from eFiling (Redux) | Variable: propertySeqRedux (UploadDrawingForm.js)"),
		// console.log(propertySeqRedux),

		// console.log("File Uploading Property (Redux) | Variable: fileUploadingPropertyRedux (UploadDrawingForm.js)"),
		// console.log(fileUploadingPropertyRedux),
		
		// console.log("Property file | Variable: propertyFiles (UploadDrawingForm.js)"),
		// console.log(propertyFiles),

		// console.log("Drawing Property Information | Variable: drawingProperty (UploadDrawingForm.js)"),
		// console.log(drawingProperty),
		
		// console.log("Drawing Property Information (Redux) | Variable: drawingPropertyRedux (UploadDrawingForm.js)"),
		// console.log(drawingPropertyRedux),

		// console.log("Validation Error | Variable: validationErrors (UploadDrawingForm.js)"),
		// console.log(validationErrors),

		// console.log("---------------------------------------------------------------------------------"),


		<Fragment>
			<div>
				<LockScreenLoading
					open={lockScreenLoadingOpen}
					circleSize={200}
					progressTitle={lockScreenProgressTitle}
				/>

				<Alert
					open={alertOpen}
					alertType={alertData.type}
					alertTitle={alertData.title}
					alertContent={alertData.content}
					handleClose={() => setAlertOpen(false)}
				/>

				<ConfirmDialog
					open={confirmDialogOpen}
					dialogTitle={confirmDialogData.dialogTitle}
					dialogContent={confirmDialogData.dialogContent}
					confirmAction={confirmDialogData.confirmAction}
					cancelAction={confirmDialogData.cancelAction}
				/>

				<FullScreenDialog
					open={fileManagerDialogOpen}
					dialogTitle={"File Choice From eFiling"}
					formContent={
						<Efiling fileManagerType={"select"} />   // main => Main File Manager, select => Select File From File Manager
					}
					button={fileManagerDialogBtn}
					handleClose={fileManagerDialogHandleClose}
				/>

				<FullScreenDialog
					open={filePreviewDialogOpen}
					dialogTitle={"Drawing Preview"}
					formContent={
						<FilePreview 
							filePreviewProperty={filePreviewProperty}
						/>
					}
					// button={circulationAttachmentPreviewDialogBtn}
					button={[]}
					handleClose={filePreviewDialogHandleClose}
				/>
			</div>


			<Grid container spacing={1} className={classes.drawingFieldArea}>
				<Grid item xs={12} sm={12} lg={4}>

					<Grid container spacing={1} className={classes.coverTypeGrid}>
						<Grid item xs={12} sm={12} lg={12}>
							<ToggleButtonGroup
								aria-label="Cover Type"
								exclusive
								value={coverType}
								onChange={handleCoverType}
								className={classes.ToggleButtonGroup}
							>
								{
									coverTypeList && coverTypeList.length > 0 ?
										coverTypeList.map((res, index) => {
											return (
												<ToggleButton
													key={index}
													aria-label={res.type_name}
													value={res}
													className={classes.ToggleButton}
												>
													<Typography color="textSecondary">{res.type_name}</Typography>
												</ToggleButton>
											)
										})
									: ""
								}
							</ToggleButtonGroup>
						</Grid>
					</Grid>

					{
						coverType && coverType.contain_ai ?
							<div className={classes.LegendArea}>
								<Legend 
									id="ai_cover"
									label="AI Cover Information"
									required={null}
									normalTitleColor={grayColor[10]}
									normalBorderColor={grayColor[4]}
									messageTitleColor={redColor[6]}
									messageBorderColor={redColor[6]}
									error={null}
									helperText={null}
								>	
									<Box className={classes.drawingPropertyArea}>
										<Grid container spacing={3} className={classes.content}>
											<Grid item xs={12} sm={12} lg={6}>
												<TextField
													id="ai_cover_no"
													name="ai_cover_no"
													label="Cover No."
													required
													fullWidth={true}
													size="small"
													variant="outlined"
													value={drawingProperty ? drawingProperty.cover.ai_cover_no : ""}
													onChange={handleTextChange}
													InputLabelProps={{
														shrink: true,
													}}
													error={validationErrors.ai_cover_no && validationErrors.ai_cover_no !== "" ? true : false}
													helperText={validationErrors.ai_cover_no}
												/>
											</Grid>

											<Grid item xs={12} sm={12} lg={6}>
												<MuiPickersUtilsProvider utils={DateFnsUtils}>
													<KeyboardDatePicker
														id="ai_issue_date"
														name="ai_issue_date"
														label="Issue Date"
														required
														format="dd/MM/yyyy"
														placeholder="DD/MM/YYYY"
														size="small"
														inputVariant="outlined"
														KeyboardButtonProps={{
															"aria-label": "change date"
														}}

														className={classes.datePickerField}
														value={drawingProperty.cover.ai_issue_date || null}
														onChange={handleAiIssueDateChange}
														InputLabelProps={{
															shrink: true,
														}}
														error={validationErrors.ai_issue_date && validationErrors.ai_issue_date !== "" ? true : false}
														helperText={validationErrors.ai_issue_date}
													/>
												</MuiPickersUtilsProvider>
											</Grid>

											{/* <Grid item xs={12} sm={12} lg={12}>
												<Autocomplete
													// multiple
													id="ai_company_seq"
													name="ai_company_seq"
													options={aiCompanyList}
													getOptionLabel={option => option.company_name}
													onChange={(event, value) => {
														handleAiSelectChange(event, value)
													}}
													renderInput={params => (
														<TextField
															{...params}
															required
															variant="outlined"
															label="Organization"
															size="small"
															value={drawingProperty && drawingProperty.company_seq !== 0 ? drawingProperty.company_seq : ""}
															InputLabelProps={{
																shrink: true,
															}}
															error={validationErrors.ai_company_seq && validationErrors.ai_company_seq !== "" ? true : false}
															helperText={validationErrors.ai_company_seq}
														/>
													)}
												/>
											</Grid> */}

											<Grid item xs={12} sm={12} lg={12}>
												<TextField
													id="ai_cover_subject"
													name="ai_cover_subject"
													label="Subject"
													required
													fullWidth={true}
													size="small"
													variant="outlined"
													value={drawingProperty ? drawingProperty.cover.ai_cover_subject : ""}
													onChange={handleTextChange}
													InputLabelProps={{
														shrink: true,
													}}
													error={validationErrors.ai_cover_subject && validationErrors.ai_cover_subject !== "" ? true : false}
													helperText={validationErrors.ai_cover_subject}
												/>
											</Grid>
										</Grid>
									</Box>
								</Legend>
							</div>

						: ""
					}

					{
						coverType && coverType.contain_bd ?
							<div className={classes.LegendArea}>
								<Legend 
									id="bd_cover"
									label="BD Approval Information"
									required={null}
									normalTitleColor={grayColor[10]}
									normalBorderColor={grayColor[4]}
									messageTitleColor={redColor[6]}
									messageBorderColor={redColor[6]}
									error={null}
									helperText={null}
								>	
									<Box className={classes.drawingPropertyArea}>
										<Grid container spacing={3} className={classes.content}>
											<Grid item xs={12} sm={12} lg={6}>
												<TextField
													id="bd_cover_no"
													name="bd_cover_no"
													label="Cover No."
													required
													fullWidth={true}
													size="small"
													variant="outlined"
													value={drawingProperty ? drawingProperty.cover.cover_no : ""}
													onChange={handleTextChange}
													InputLabelProps={{
														shrink: true,
													}}
													error={validationErrors.bd_cover_no && validationErrors.bd_cover_no !== "" ? true : false}
													helperText={validationErrors.bd_cover_no}
												/>
											</Grid>

											<Grid item xs={12} sm={12} lg={6}>
												<MuiPickersUtilsProvider utils={DateFnsUtils}>
													<KeyboardDatePicker
														id="bd_issue_date"
														name="bd_issue_date"
														label="Issue Date"
														required
														format="dd/MM/yyyy"
														placeholder="DD/MM/YYYY"
														size="small"
														inputVariant="outlined"
														KeyboardButtonProps={{
															"aria-label": "change date"
														}}

														className={classes.datePickerField}
														value={drawingProperty.cover.bd_issue_date || null}
														onChange={handleBdIssueDateChange}
														InputLabelProps={{
															shrink: true,
														}}
														error={validationErrors.bd_issue_date && validationErrors.bd_issue_date !== "" ? true : false}
														helperText={validationErrors.bd_issue_date}
													/>
												</MuiPickersUtilsProvider>
											</Grid>

											{/* <Grid item xs={12} sm={12} lg={12}>
												<Autocomplete
													// multiple
													id="bd_company_seq"
													name="bd_company_seq"
													options={bdCompanyList}
													getOptionLabel={option => option.company_name}
													onChange={(event, value) => {
														handleBdSelectChange(event, value)
													}}
													renderInput={params => (
														<TextField
															{...params}
															required
															variant="outlined"
															label="Organization"
															size="small"
															// value={drawingProperty && drawingProperty.company_seq !== 0 ? drawingProperty.company_seq : ""}
															InputLabelProps={{
																shrink: true,
															}}
															error={validationErrors.bd_company_seq && validationErrors.bd_company_seq !== "" ? true : false}
															helperText={validationErrors.bd_company_seq}
														/>
													)}
												/>
											</Grid> */}

											<Grid item xs={12} sm={12} lg={12}>
												<TextField
													id="bd_cover_subject"
													name="bd_cover_subject"
													label="Subject"
													required
													fullWidth={true}
													size="small"
													variant="outlined"
													value={drawingProperty ? drawingProperty.cover.cover_subject : ""}
													onChange={handleTextChange}
													InputLabelProps={{
														shrink: true,
													}}
													error={validationErrors.bd_cover_subject && validationErrors.bd_cover_subject !== "" ? true : false}
													helperText={validationErrors.bd_cover_subject}
												/>
											</Grid>
										</Grid>
									</Box>
								</Legend>
							</div>
						: ""
					}

					{
						coverType ?
							<div className={classes.LegendArea}>
								<Legend
									id="ai_file_upload"
									label="File Upload *"
									required={true}

									normalTitleColor={grayColor[10]}
									normalBorderColor={grayColor[4]}
									messageTitleColor={redColor[6]}
									messageBorderColor={redColor[6]}

									error={validationErrors.files && validationErrors.files !== "" ? true : false}
									helperText={validationErrors.files}
								>
									<Box className={classes.addFileBtnArea}>
										<FileDropzone
											key={"drawing_file_upload"}
											title={""}
											fileType={"drawing_file"}
											disabled={false}
											fileUploadAction={fileUploadAction}
											fileRemoveAction={removeFileConfirmAction}
											viewFileAction={viewFileAction}
											DropzoneContent={DrawingFileZoneContent}
											openFileManagerDialog={fileManagerDialogHandleOpen}
										/>
									</Box>
								</Legend>
							</div>
						: ""
					}

					{
						coverType ?
							<Box className={classes.addFileBtnArea}>
								{
									<Tooltip title="Upload Drawing">
										<Fab color="primary" size="small" aria-label="upload" className={classes.uploadAreaBtn} onClick={uploadDrawingConfirmAction}>
											<PublishIcon />
										</Fab>
									</Tooltip>
								}
							</Box>
						: ""
					}

				</Grid>

				<Grid item xs={12} sm={12} lg={8}>
					<WebViewer 
						property={webViewProps}
						closeDoc={webViewCloseDoc}
					/>
				</Grid>
			</Grid>
		</Fragment>
	)
}


export default UploadDrawingForm